import { render, staticRenderFns } from "./FormulaireBatteries.vue?vue&type=template&id=006639a6&"
import script from "./FormulaireBatteries.vue?vue&type=script&lang=js&"
export * from "./FormulaireBatteries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports